import styled from 'styled-components';
import { secondary, darkGray } from 'styles/colorProvider';

export const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.outlined ? 'transparent' : secondary)};
  border: ${(props) => (props.outlined ? `1px solid ${secondary}` : 'none')};
  outline: none;
  cursor: pointer;
  margin: ${(props) => `${props.marginVertical || 10}px ${props.marginHorizontal || 10}px`};
  transition: all ease-in-out 0.3s;
  font-size: ${(props) => props.fontSize || '15px'};
  border-radius: 50px;
  height: ${(props) => props.height || '45px'};
  width: ${(props) => props.width || '180px'};
  color: ${darkGray};

  &&:hover {
    opacity: 0.7;
    color: ${darkGray};
  }
  &&:disabled {
    opacity: 0.7;
    cursor: default;
    color: ${darkGray};
  }

  @media (max-width: 1000px) {
    width: ${(props) => props.mobileWidth || '100%'};
  }
`;
